// importer vos composantes ici
import Form from './components/Form.js';
import Carousel from './components/Carousel.js';
import Header from './components/Header.js';
import Youtube from './components/Youtube.js';
import Scrolly from './components/Scrolly.js';
import TextAnim from './components/TextAnim.js';
import Scroller from './components/Scroller.js';
import Experience from './components/Experience.js';
import Accordion from './components/Accordion.js';
import ModelCarousel from './components/ModelCarousel.js';
import SingleModel from './components/SingleModel.js';
import DepthCarousel from './components/DepthCarousel.js';
import AccessoireModel from './components/AccessoireModel.js';
import TeamModal from './components/TeamModal.js';
import CreditsModal from './components/CreditsModal.js';
import PatternWaves from './components/PatternWaves.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Form,
      Carousel,
      Youtube,
      Header,
      Scrolly,
      TextAnim,
      Scroller,
      Experience,
      Accordion,
      ModelCarousel,
      SingleModel,
      DepthCarousel,
      AccessoireModel,
      TeamModal,
      CreditsModal,
      PatternWaves,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
